import { render, staticRenderFns } from "./customerServicePage.vue?vue&type=template&id=3d99431c&"
import script from "./customerServicePage.vue?vue&type=script&lang=js&"
export * from "./customerServicePage.vue?vue&type=script&lang=js&"
import style0 from "./customerServicePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports